import React from 'react';
import Component from '@vfuk/core-loading-spinner';
const LoadingSpinner = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default LoadingSpinner;
